module.exports = __webpack_public_path__ + "static/media/input.032c8d25.svg";